import { render } from 'preact'
import { Router, Route } from 'preact-router'
import './styles.css'

import { Header } from './components/Header.jsx'
import { Footer } from './components/Footer.jsx'
import { Explore } from './pages/Explore.jsx'

const App = () => (
  <div className="min-h-screen bg-gradient-to-br from-black via-red-950/20 to-black">
    <Header />
    <main className="flex-1">
      <Router>
        <Route path="/" component={Explore} />
      </Router>
    </main>
    <Footer />
  </div>
)

render(<App />, document.getElementById('app'))
